module.exports = {
  size: {
    sm: {
      icon: 'components.icon.sm',
      font: 'font.size.xxs',
    },
    md: {
      icon: 'components.icon.md',
      font: 'font.size.xxs',
    },
    lg: {
      icon: 'components.icon.lg',
      font: 'font.size.xxs',
    },
  },
};
